/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Grid } from "@material-ui/core";

//custom libraries
import { AddCustomerForm } from "../containers";
import { ContentSection } from "../components";

export default function AddCustomer() {
  return (
    <Grid container className="min-content-height"> 
      <ContentSection fullWidth>
        <AddCustomerForm />
      </ContentSection>
    </Grid>
  );
}
